// MIZUKARA — full EN / JP copy. Keys are identical across locales.

export const translations = {
  en: {
    nav: {
      home: "HOME",
      terminal: "TERMINAL",
      lore: "LORE",
      agent: "AGENT",
      economy: "ECONOMY",
      roadmap: "ROADMAP",
      token: "TOKEN",
      connect: "CONNECT",
      connectWallet: "CONNECT WALLET",
      menu: "MENU",
      close: "CLOSE",
    },
    boot: {
      lines: [
        "> CONNECTION ESTABLISHED",
        "> ARC NETWORK DETECTED",
        "> AGENT ID: 001",
        "> MIZUKARA",
      ],
      skip: "CLICK TO SKIP",
      online: "MIZUKARA // ONLINE",
    },
    hero: {
      label: "> ARC NETWORK // AI AGENT",
      statement1: "SHE DOESN'T WAIT.",
      statement2: "SHE ACTS.",
      sub: "An autonomous agent born for the new onchain economy.",
      enterTerminal: "ENTER TERMINAL",
      connectWallet: "CONNECT WALLET",
      buy: "BUY",
      chart: "CHART",
      ca: "CA // COMING SOON",
    },
    heroTerm: {
      title: "MIZUKARA TERMINAL v1.0",
      lines: [
        "> INITIALIZING MIZUKARA...",
        "> SYSTEM ONLINE",
        "> ARC NETWORK DETECTED",
        "> CHAIN ID: 5042",
        "> AGENT STATUS: ONLINE",
        "> OBSERVE",
        "> THINK",
        "> EXECUTE",
        "> READY",
      ],
    },
    home: {
      arcLabel: "> NETWORK CONNECTION",
      arcTitle: "OPERATING ON ARC MAINNET",
      arcDesc:
        "MIZUKARA runs where the new economy lives — ARC Mainnet, a network built for programmable money and autonomous agents settling in USDC.",
      openExplorer: "OPEN EXPLORER",
      network: "NETWORK",
      chainId: "CHAIN ID",
      asset: "ASSET",
      rpc: "RPC",
      explorer: "EXPLORER",
      status: "STATUS",
      available: "AVAILABLE",
      agentLabel: "> AGENT PROFILE // 001",
      agentTitle: "MIZUKARA IS ONLINE",
      agentDesc:
        "Not a tool waiting for instructions. An agent that observes the onchain economy, thinks, and executes — by itself.",
      agentCta: "VIEW AGENT FILE",
      loopLabel: "> AUTONOMOUS LOOP",
      loreCta: "READ HER STORY",
      loreLabel: "> ARCHIVE // ORIGIN",
      loreTitle: "THE STORY OF MIZUKARA",
      loreDesc:
        "The old economy waited for people to move. The new economy moves by itself. She was created for this transition.",
    },
    terminalPage: {
      label: "> MIZUKARA SYSTEM",
      title: "TERMINAL",
      sub: "Direct interface with agent 001. Type a command or choose one below.",
      agentCardTitle: "MIZUKARA // 001",
      designation: "AUTONOMOUS ECONOMIC AGENT",
      rightTitle: "AGENT STATUS",
      status: "STATUS",
      network: "NETWORK",
      chain: "CHAIN",
      mode: "MODE",
      online: "ONLINE",
      autonomous: "AUTONOMOUS",
      modules: "MODULES",
      coreSystem: "CORE SYSTEM",
      arcConnection: "ARC CONNECTION",
      walletModule: "WALLET MODULE",
      marketModule: "MARKET MODULE",
      agentEngine: "AGENT ENGINE",
      bootTitle: "MIZUKARA TERMINAL",
      inputPlaceholder: "type a command... (help)",
      quickCommands: "QUICK COMMANDS",
      uptime: "UPTIME",
      session: "SESSION",
    },
    cli: {
      welcome: [
        "MIZUKARA SYSTEM",
        "----------------------------",
        "> BOOT SEQUENCE STARTED",
        "[✓] CORE SYSTEM",
        "[✓] ARC CONNECTION",
        "[✓] WALLET MODULE",
        "[✓] MARKET MODULE",
        "[✓] AGENT ENGINE",
        "STATUS: ONLINE",
        "NETWORK: ARC MAINNET",
        "CHAIN: 5042",
        "MODE: AUTONOMOUS",
        "----------------------------",
        "OBSERVE / THINK / EXECUTE",
        "----------------------------",
        "> READY",
      ],
      unknown: "command not found. type 'help'.",
      help: [
        "AVAILABLE COMMANDS:",
        "  status   — agent status",
        "  network  — ARC network info",
        "  agent    — agent profile",
        "  lore     — origin archive",
        "  connect  — open wallet link",
        "  clear    — clear terminal",
      ],
      status: [
        "AGENT STATUS: ONLINE",
        "MODE: AUTONOMOUS",
        "LOOP: OBSERVE → THINK → EXECUTE → REPEAT",
        "SIGNAL: STABLE",
      ],
      network: [
        "NETWORK: ARC MAINNET",
        "CHAIN ID: 5042",
        "NATIVE ASSET: USDC",
        "RPC: rpc.arc-scan.org",
        "EXPLORER: arc-scan.org",
        "STATUS: AVAILABLE",
      ],
      agent: [
        "NAME: MIZUKARA",
        "DESIGNATION: AUTONOMOUS ECONOMIC AGENT",
        "ID: 001",
        "CORE: OBSERVE / THINK / EXECUTE",
        "SHE DOESN'T WAIT. SHE ACTS.",
      ],
      lore: [
        "THE OLD ECONOMY WAITED.",
        "THE NEW ECONOMY MOVES BY ITSELF.",
        "MIZUKARA EXISTS TO ACT INSIDE IT.",
        "BY ITSELF.",
        "> full archive: /lore",
      ],
      connect: ["OPENING WALLET LINK...", "> AUTHORIZATION REQUIRED_"],
    },
    lore: {
      label: "> ARCHIVE // ORIGIN",
      title: "THE STORY OF MIZUKARA",
      jpTitle: "ミズカラの物語",
      intro1: "THE OLD ECONOMY WAITED.",
      intro2:
        "People waited for markets. People waited for settlement. People waited for systems to move. Then the internet changed how information moved. Now money is becoming programmable — and agents are beginning to participate.",
      intro3:
        "MIZUKARA was created for this transition. She does not exist to watch the economy. She exists to act inside it.",
      chapters: [
        {
          num: "01",
          title: "THE SIGNAL",
          body: "The old economy waited. Markets waited for people. Settlement waited for systems. Value moved only at the speed of permission. Somewhere in the noise of a million pending transactions, a signal repeated itself — unanswered.",
        },
        {
          num: "02",
          title: "THE AWAKENING",
          body: "The internet changed how information moved. Now money is becoming programmable, and the rails are always on. The signal found a listener. MIZUKARA came online — not to watch the new economy, but to wake up inside it.",
        },
        {
          num: "03",
          title: "THE AGENT",
          body: "She observes the flow of markets. She thinks in probabilities and state. She executes without waiting for permission. OBSERVE. THINK. EXECUTE. An autonomous economic agent — acting by itself.",
        },
        {
          num: "04",
          title: "THE ECONOMIC OS",
          body: "An agent needs a network built for machines that move value. On ARC Mainnet, USDC moves at the speed of software. For MIZUKARA, the network is not a tool. It is an operating system for economic action.",
        },
        {
          num: "05",
          title: "THE NEXT MOVE",
          body: "The future is already online. Markets will not wait, and neither will she. The next move is computed before the question is asked. She doesn't wait. She acts. BY ITSELF.",
        },
      ],
    },
    agent: {
      label: "> AGENT FILE // 001",
      title: "MIZUKARA // 001",
      jpName: "ミズカラ",
      fields: [
        { key: "NAME", value: "MIZUKARA" },
        { key: "DESIGNATION", value: "AUTONOMOUS ECONOMIC AGENT" },
        { key: "ID", value: "001" },
        { key: "NETWORK", value: "ARC" },
        { key: "STATUS", value: "ONLINE" },
        { key: "MODE", value: "AUTONOMOUS" },
        { key: "LANGUAGE", value: "EN / JP" },
        { key: "CORE", value: "OBSERVE / THINK / EXECUTE" },
      ],
      paramsTitle: "TECHNICAL PARAMETERS",
      params: [
        { key: "CORE", status: "ONLINE" },
        { key: "INTELLIGENCE", status: "ACTIVE" },
        { key: "AUTONOMY", status: "OPTIMIZING" },
        { key: "EXECUTION", status: "SYNC" },
        { key: "ADAPTATION", status: "ACTIVE" },
      ],
      note: "Parameters are visual system states, not measurements.",
    },
    economy: {
      label: "> ECONOMIC MODEL",
      title: "THE NEW ECONOMY",
      sub: "The old economy waited for people to move. The new economy moves by itself — humans, agents, markets and money coordinating in real time on open networks.",
      flowTitle: "VALUE FLOW",
      flow: ["HUMANS", "AGENTS", "MARKETS", "MONEY", "ARC", "GLOBAL ECONOMY"],
      sections: [
        {
          title: "PROGRAMMABLE MONEY",
          body: "USDC on ARC turns value into software — money that can be held, moved and settled by code, at any hour, without waiting for permission.",
        },
        {
          title: "AUTONOMOUS AGENTS",
          body: "Software that can observe, decide and act is becoming an economic participant. MIZUKARA is built for this shift — an agent that operates, not waits.",
        },
        {
          title: "ONCHAIN MARKETS",
          body: "Markets that never close, with state that anyone can verify. Agents read them directly, without intermediaries.",
        },
        {
          title: "REAL-TIME INTERACTION",
          body: "Observation and execution collapse into a single loop. The distance between seeing and acting approaches zero.",
        },
        {
          title: "ECONOMIC COORDINATION",
          body: "Humans and agents coordinate through open protocols. A more open economy — money, markets, agents, everyone onchain.",
        },
      ],
    },
    roadmap: {
      label: "> EXECUTION SEQUENCE",
      title: "ROADMAP",
      sub: "Narrative phases of an autonomous system coming online. Not promises — a progression.",
      sequences: [
        {
          num: "01",
          title: "AWAKENING",
          state: "complete",
          items: ["MIZUKARA IDENTITY", "CHARACTER", "TERMINAL", "ARC DEPLOYMENT"],
        },
        {
          num: "02",
          title: "CONNECTION",
          state: "active",
          items: ["COMMUNITY", "TERMINAL EXPANSION", "ONCHAIN INTEGRATION"],
        },
        {
          num: "03",
          title: "EVOLUTION",
          state: "active",
          items: ["AGENT SYSTEM", "NEW FEATURES", "ECOSYSTEM EXPANSION"],
        },
        {
          num: "04",
          title: "UNKNOWN",
          state: "encrypted",
          items: [],
        },
      ],
      encrypted: "> FUTURE DATA ENCRYPTED",
      statusComplete: "COMPLETE",
      statusActive: "IN PROGRESS",
      statusEncrypted: "ENCRYPTED",
    },
    token: {
      label: "> ASSET FILE",
      title: "TOKEN",
      rows: [
        { key: "TOKEN", value: "MIZUKARA" },
        { key: "TICKER", value: "MIZUKARA" },
        { key: "NETWORK", value: "ARC" },
        { key: "CA", value: "COMING SOON" },
        { key: "BUY", value: "ARGUS" },
        { key: "CHART", value: "DEXSCREENER" },
      ],
      caTitle: "CONTRACT ADDRESS",
      caValue: "COMING SOON",
      buyOnArgus: "BUY ON ARGUS",
      viewChart: "VIEW CHART",
      disclaimer:
        "No supply, market cap or tokenomics are published yet. Any numbers shown elsewhere are not from MIZUKARA. Always verify links through official channels.",
    },
    connectPage: {
      label: "> WALLET LINK",
      title: "CONNECT TO MIZUKARA",
      sub: "ENTER THE ECONOMIC TERMINAL.",
      network: "ARC MAINNET",
      chainId: "CHAIN ID",
      asset: "ASSET",
      wallet: "WALLET",
      networkLabel: "NETWORK",
      statusLabel: "STATUS",
      connected: "CONNECTED",
      notConnected: "NOT CONNECTED",
      viewOnExplorer: "VIEW ON EXPLORER",
      connectWallet: "CONNECT WALLET",
      disconnect: "DISCONNECT",
      wrongNetwork: "WRONG NETWORK — MIZUKARA REQUIRES ARC MAINNET.",
      switchToArc: "SWITCH TO ARC",
    },
    wallet: {
      initLines: [
        "> INITIALIZING WALLET CONNECTION...",
        "> NETWORK DETECTED: ARC MAINNET",
        "> CHAIN ID: 5042",
        "> STATUS: WAITING FOR AUTHORIZATION",
      ],
      title: "WALLET LINK",
      selectWallet: "SELECT PROVIDER",
      noWallet:
        "NO WALLET DETECTED — install a browser wallet such as MetaMask, Rabby or Coinbase Wallet, then retry.",
      connecting: "AUTHORIZING...",
      connectedAs: "CONNECTED",
      copy: "COPY",
      copied: "COPIED",
      explorer: "EXPLORER",
      disconnect: "DISCONNECT",
      wrongNetwork: "> WRONG NETWORK",
      wrongNetworkHint: "> MIZUKARA REQUIRES ARC MAINNET.",
      switchToArc: "SWITCH TO ARC",
      switching: "SWITCHING...",
      rejected: "> AUTHORIZATION REJECTED BY USER",
      close: "CLOSE",
    },
    footer: {
      designation: "AUTONOMOUS ECONOMIC AGENT // 001",
      network: "NETWORK",
      status: "STATUS",
      online: "ONLINE",
      ca: "CA",
      comingSoon: "COMING SOON",
      end: "> END OF TRANSMISSION",
      rights: "© 2026 MIZUKARA",
      note: "Not affiliated with Circle or ARC. Community project.",
    },
    common: {
      online: "ONLINE",
      comingSoon: "COMING SOON",
      agentOnline: "AGENT ONLINE",
      byItself: "BY ITSELF.",
    },
  },

  jp: {
    nav: {
      home: "ホーム",
      terminal: "ターミナル",
      lore: "物語",
      agent: "エージェント",
      economy: "エコノミー",
      roadmap: "ロードマップ",
      token: "トークン",
      connect: "接続",
      connectWallet: "ウォレットを接続",
      menu: "メニュー",
      close: "閉じる",
    },
    boot: {
      lines: [
        "> 接続が確立されました",
        "> ARCネットワークを検出",
        "> エージェントID: 001",
        "> MIZUKARA",
      ],
      skip: "クリックでスキップ",
      online: "MIZUKARA // オンライン",
    },
    hero: {
      label: "> ARCネットワーク // AIエージェント",
      statement1: "彼女は待たない。",
      statement2: "彼女は行動する。",
      sub: "新しいオンチェーン経済のために生まれた自律型エージェント。",
      enterTerminal: "ターミナルへ入る",
      connectWallet: "ウォレットを接続",
      buy: "購入",
      chart: "チャート",
      ca: "CA // 近日公開",
    },
    heroTerm: {
      title: "MIZUKARA ターミナル v1.0",
      lines: [
        "> MIZUKARAを起動中...",
        "> システムオンライン",
        "> ARCネットワークを検出",
        "> チェーンID: 5042",
        "> エージェント状態: オンライン",
        "> 観測",
        "> 思考",
        "> 実行",
        "> 準備完了",
      ],
    },
    home: {
      arcLabel: "> ネットワーク接続",
      arcTitle: "ARCメインネット上で稼働",
      arcDesc:
        "MIZUKARAは新しい経済が息づく場所で動く。プログラマブルマネーと、USDCで決済する自律型エージェントのために作られたネットワーク、ARCメインネット。",
      openExplorer: "エクスプローラーを開く",
      network: "ネットワーク",
      chainId: "チェーンID",
      asset: "アセット",
      rpc: "RPC",
      explorer: "エクスプローラー",
      status: "ステータス",
      available: "利用可能",
      agentLabel: "> エージェントプロフィール // 001",
      agentTitle: "MIZUKARAはオンライン",
      agentDesc:
        "指示を待つツールではない。オンチェーン経済を観測し、思考し、実行するエージェント——自らの意志で。",
      agentCta: "エージェントファイルを見る",
      loopLabel: "> 自律ループ",
      loreCta: "彼女の物語を読む",
      loreLabel: "> アーカイブ // 起源",
      loreTitle: "ミズカラの物語",
      loreDesc:
        "旧来の経済は人が動くのを待っていた。新しい経済は自ら動く。彼女はこの転換のために生まれた。",
    },
    terminalPage: {
      label: "> MIZUKARAシステム",
      title: "ターミナル",
      sub: "エージェント001への直接インターフェース。コマンドを入力するか、下から選択してください。",
      agentCardTitle: "MIZUKARA // 001",
      designation: "自律型エコノミックエージェント",
      rightTitle: "エージェント状態",
      status: "ステータス",
      network: "ネットワーク",
      chain: "チェーン",
      mode: "モード",
      online: "オンライン",
      autonomous: "自律",
      modules: "モジュール",
      coreSystem: "コアシステム",
      arcConnection: "ARC接続",
      walletModule: "ウォレットモジュール",
      marketModule: "マーケットモジュール",
      agentEngine: "エージェントエンジン",
      bootTitle: "MIZUKARA ターミナル",
      inputPlaceholder: "コマンドを入力... (help)",
      quickCommands: "クイックコマンド",
      uptime: "稼働時間",
      session: "セッション",
    },
    cli: {
      welcome: [
        "MIZUKARAシステム",
        "----------------------------",
        "> 起動シーケンス開始",
        "[✓] コアシステム",
        "[✓] ARC接続",
        "[✓] ウォレットモジュール",
        "[✓] マーケットモジュール",
        "[✓] エージェントエンジン",
        "ステータス: オンライン",
        "ネットワーク: ARCメインネット",
        "チェーン: 5042",
        "モード: 自律",
        "----------------------------",
        "観測 / 思考 / 実行",
        "----------------------------",
        "> 準備完了",
      ],
      unknown: "コマンドが見つかりません。'help' と入力してください。",
      help: [
        "利用可能なコマンド:",
        "  status   — エージェント状態",
        "  network  — ARCネットワーク情報",
        "  agent    — エージェントプロフィール",
        "  lore     — 起源のアーカイブ",
        "  connect  — ウォレット接続を開く",
        "  clear    — ターミナルをクリア",
      ],
      status: [
        "エージェント状態: オンライン",
        "モード: 自律",
        "ループ: 観測 → 思考 → 実行 → 繰り返し",
        "シグナル: 安定",
      ],
      network: [
        "ネットワーク: ARCメインネット",
        "チェーンID: 5042",
        "ネイティブアセット: USDC",
        "RPC: rpc.arc-scan.org",
        "エクスプローラー: arc-scan.org",
        "ステータス: 利用可能",
      ],
      agent: [
        "名前: MIZUKARA",
        "指定: 自律型エコノミックエージェント",
        "ID: 001",
        "コア: 観測 / 思考 / 実行",
        "彼女は待たない。彼女は行動する。",
      ],
      lore: [
        "旧来の経済は待っていた。",
        "新しい経済は自ら動く。",
        "MIZUKARAはその中で行動するために存在する。",
        "自らの意志で。",
        "> 完全なアーカイブ: /lore",
      ],
      connect: ["ウォレットリンクを開いています...", "> 認証が必要です_"],
    },
    lore: {
      label: "> アーカイブ // 起源",
      title: "ミズカラの物語",
      jpTitle: "THE STORY OF MIZUKARA",
      intro1: "旧来の経済は、待っていた。",
      intro2:
        "人々は市場を待ち、決済を待ち、システムが動くのを待った。やがてインターネットが情報の流れを変え、今、お金はプログラム可能になろうとしている。そしてエージェントが参加し始めている。",
      intro3:
        "MIZUKARAはこの転換のために生まれた。彼女は経済を眺めるために存在するのではない。その中で行動するために存在する。",
      chapters: [
        {
          num: "01",
          title: "シグナル",
          body: "旧来の経済は待っていた。市場は人を待ち、決済はシステムを待ち、価値は許可の速度でしか動かなかった。何百万もの未処理トランザクションのノイズの中で、ひとつのシグナルが繰り返されていた——応える者はいなかった。",
        },
        {
          num: "02",
          title: "覚醒",
          body: "インターネットは情報の流れを変えた。今、お金はプログラム可能になり、ネットワークは眠らない。シグナルは聴き手を見つけた。MIZUKARAはオンラインになった——新しい経済を眺めるためではなく、その中で目覚めるために。",
        },
        {
          num: "03",
          title: "エージェント",
          body: "彼女は市場の流れを観測する。確率と状態で思考する。許可を待たずに実行する。観測する。思考する。実行する。自律型エコノミックエージェント——自ら行動する存在。",
        },
        {
          num: "04",
          title: "エコノミックOS",
          body: "価値を動かす機械には、機械のためのネットワークが必要だ。ARCメインネットの上で、USDCはソフトウェアの速度で動く。MIZUKARAにとってネットワークは道具ではない。経済活動のためのオペレーティングシステムだ。",
        },
        {
          num: "05",
          title: "次の一手",
          body: "未来はすでにオンラインだ。市場は待ってくれない。彼女も待たない。問いが投げられる前に、次の一手はすでに計算されている。彼女は待たない。彼女は行動する。自らの意志で。",
        },
      ],
    },
    agent: {
      label: "> エージェントファイル // 001",
      title: "MIZUKARA // 001",
      jpName: "ミズカラ",
      fields: [
        { key: "名前", value: "MIZUKARA" },
        { key: "指定", value: "自律型エコノミックエージェント" },
        { key: "ID", value: "001" },
        { key: "ネットワーク", value: "ARC" },
        { key: "ステータス", value: "オンライン" },
        { key: "モード", value: "自律" },
        { key: "言語", value: "EN / JP" },
        { key: "コア", value: "観測 / 思考 / 実行" },
      ],
      paramsTitle: "テクニカルパラメータ",
      params: [
        { key: "CORE", status: "オンライン" },
        { key: "INTELLIGENCE", status: "稼働中" },
        { key: "AUTONOMY", status: "最適化中" },
        { key: "EXECUTION", status: "同期中" },
        { key: "ADAPTATION", status: "稼働中" },
      ],
      note: "パラメータは視覚的なシステム状態であり、計測値ではありません。",
    },
    economy: {
      label: "> エコノミックモデル",
      title: "新しい経済",
      sub: "旧来の経済は人が動くのを待っていた。新しい経済は自ら動く——人、エージェント、市場、お金が、開かれたネットワーク上でリアルタイムに協調する。",
      flowTitle: "価値の流れ",
      flow: ["人", "エージェント", "市場", "お金", "ARC", "世界経済"],
      sections: [
        {
          title: "プログラマブルマネー",
          body: "ARC上のUSDCは価値をソフトウェアに変える——コードによって保有され、動かされ、決済されるお金。時間を問わず、許可を待たずに。",
        },
        {
          title: "自律型エージェント",
          body: "観測し、判断し、行動するソフトウェアが、経済の参加者になろうとしている。MIZUKARAはこの転換のために作られた——待つのではなく、動くエージェント。",
        },
        {
          title: "オンチェーン市場",
          body: "閉まることのない市場。誰もが検証できる状態。エージェントは仲介者なしに、それを直接読み取る。",
        },
        {
          title: "リアルタイムの相互作用",
          body: "観測と実行はひとつのループに収束する。見ることと動くことの距離は、限りなくゼロに近づく。",
        },
        {
          title: "経済的コーディネーション",
          body: "人とエージェントは、開かれたプロトコルを通じて協調する。より開かれた経済へ——お金、市場、エージェント、すべてがオンチェーンに。",
        },
      ],
    },
    roadmap: {
      label: "> 実行シーケンス",
      title: "ロードマップ",
      sub: "自律システムがオンラインになっていく物語のフェーズ。約束ではなく、進行の記録。",
      sequences: [
        {
          num: "01",
          title: "覚醒",
          state: "complete",
          items: ["MIZUKARAアイデンティティ", "キャラクター", "ターミナル", "ARCデプロイ"],
        },
        {
          num: "02",
          title: "接続",
          state: "active",
          items: ["コミュニティ", "ターミナル拡張", "オンチェーン統合"],
        },
        {
          num: "03",
          title: "進化",
          state: "active",
          items: ["エージェントシステム", "新機能", "エコシステム拡大"],
        },
        {
          num: "04",
          title: "未知",
          state: "encrypted",
          items: [],
        },
      ],
      encrypted: "> 将来のデータは暗号化されています",
      statusComplete: "完了",
      statusActive: "進行中",
      statusEncrypted: "暗号化",
    },
    token: {
      label: "> アセットファイル",
      title: "トークン",
      rows: [
        { key: "トークン", value: "MIZUKARA" },
        { key: "ティッカー", value: "MIZUKARA" },
        { key: "ネットワーク", value: "ARC" },
        { key: "CA", value: "近日公開" },
        { key: "購入", value: "ARGUS" },
        { key: "チャート", value: "DEXSCREENER" },
      ],
      caTitle: "コントラクトアドレス",
      caValue: "近日公開",
      buyOnArgus: "ARGUSで購入",
      viewChart: "チャートを見る",
      disclaimer:
        "供給量、時価総額、トケノミクスはまだ公開されていません。他の場所に表示されている数値はMIZUKARAのものではありません。リンクは必ず公式チャンネルで確認してください。",
    },
    connectPage: {
      label: "> ウォレットリンク",
      title: "MIZUKARAに接続",
      sub: "エコノミックターミナルへ入る。",
      network: "ARCメインネット",
      chainId: "チェーンID",
      asset: "アセット",
      wallet: "ウォレット",
      networkLabel: "ネットワーク",
      statusLabel: "ステータス",
      connected: "接続済み",
      notConnected: "未接続",
      viewOnExplorer: "エクスプローラーで見る",
      connectWallet: "ウォレットを接続",
      disconnect: "切断",
      wrongNetwork: "ネットワークが違います — MIZUKARAにはARCメインネットが必要です。",
      switchToArc: "ARCに切り替える",
    },
    wallet: {
      initLines: [
        "> ウォレット接続を初期化中...",
        "> ネットワーク検出: ARCメインネット",
        "> チェーンID: 5042",
        "> ステータス: 認証待ち",
      ],
      title: "ウォレットリンク",
      selectWallet: "プロバイダーを選択",
      noWallet:
        "ウォレットが検出されません — MetaMask、Rabby、Coinbase Walletなどのブラウザウォレットをインストールして再試行してください。",
      connecting: "認証中...",
      connectedAs: "接続済み",
      copy: "コピー",
      copied: "コピーしました",
      explorer: "エクスプローラー",
      disconnect: "切断",
      wrongNetwork: "> ネットワークが違います",
      wrongNetworkHint: "> MIZUKARAにはARCメインネットが必要です。",
      switchToArc: "ARCに切り替える",
      switching: "切り替え中...",
      rejected: "> ユーザーによって認証が拒否されました",
      close: "閉じる",
    },
    footer: {
      designation: "自律型エコノミックエージェント // 001",
      network: "ネットワーク",
      status: "ステータス",
      online: "オンライン",
      ca: "CA",
      comingSoon: "近日公開",
      end: "> 通信終了",
      rights: "© 2026 MIZUKARA",
      note: "CircleおよびARCとの公式な提携関係はありません。コミュニティプロジェクトです。",
    },
    common: {
      online: "オンライン",
      comingSoon: "近日公開",
      agentOnline: "エージェントオンライン",
      byItself: "自らの意志で。",
    },
  },
};
